import { useCallback, useState } from 'react';
import { STAT_CARD_IDS, type StatCardId } from '../utils/buildPageCards';

export const DASHBOARD_STAT_CARD_ORDER_STORAGE_KEY = 'womanalytics.dashboard.statCardOrder';

function normalizeOrder(parsed: unknown): StatCardId[] | null {
  if (!Array.isArray(parsed)) return null;
  const valid = new Set<string>(STAT_CARD_IDS);
  const seen = new Set<string>();
  const result: StatCardId[] = [];
  for (const id of parsed) {
    if (typeof id === 'string' && valid.has(id) && !seen.has(id)) {
      result.push(id as StatCardId);
      seen.add(id);
    }
  }
  for (const id of STAT_CARD_IDS) {
    if (!seen.has(id)) result.push(id);
  }
  return result;
}

export function useDashboardStatCardOrder() {
  const [order, setOrderState] = useState<StatCardId[]>(() => {
    try {
      const raw = localStorage.getItem(DASHBOARD_STAT_CARD_ORDER_STORAGE_KEY);
      if (raw) {
        const n = normalizeOrder(JSON.parse(raw));
        if (n) return n;
      }
    } catch {
      /* ignore */
    }
    return [...STAT_CARD_IDS];
  });

  const setOrder = useCallback((next: StatCardId[]) => {
    setOrderState(next);
    try {
      localStorage.setItem(DASHBOARD_STAT_CARD_ORDER_STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* ignore */
    }
  }, []);

  return { order, setOrder };
}

export function resetDashboardStatCardOrderStorage(): boolean {
  try {
    localStorage.removeItem(DASHBOARD_STAT_CARD_ORDER_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}
